<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import { devices } from '../../../stores';
	import type { FlowNode, NodeData } from '../types/flow-types';
	import { generateScriptActionLabel } from '../PropertyEditors/helpers/LabelGenerator';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = (() => {
		$devices;
		return generateScriptActionLabel({
			id,
			type: 'scriptAction',
			position: { x: 0, y: 0 },
			data,
		} as FlowNode);
	})();
</script>

<BaseNode
	{id}
	type="scriptAction"
	{data}
	{selected}
	{validated}
	{errors}
	hideOutputPort={true}
	cardTitle={String(displayText)}
	nodeTypeLabel="Script action"
	avatarOverride={{ icon: 'fa-solid fa-brackets-curly', backgroundColor: 'color-green' }}
	{...$$restProps}
/>
